module.exports = __webpack_public_path__ + "static/media/poonam.fc1907b1.jpg";